import styled from 'styled-components';
//import { Palette } from 'config';

export const Header = styled.div`
  width: 200px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: #0f172a;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
`;
export const RecommendationRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 16px;
`;
export const WhiteFlexColumn = styled.div`
  gap: 4px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 4px;
  overflow: hidden;
`;
export const Title = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;
export const Lightbulbfill = styled.img`
  width: 16px;
  height: 16px;
`;
export const Label = styled.div`
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: Roboto;
  line-height: 16px;
  white-space: nowrap;
`;
export const Description = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px 0px 0px 20px;
`;
export const Label1 = styled.div`
  width: 164px;
  flex-grow: 1;
  color: #64748b;
  font-size: 12px;
  font-family: Roboto;
  line-height: 16px;
`;
